import Dexie from 'dexie'

const globalUser = global.rootRequire('classes/globalUser')

const db = new Dexie('store');
// const db = new Dexie('store_BOBACU');

db.version(1).stores(
  { groups: "group_id,last_sort,name,type,updated_at,timestamp" }
)

db.version(1).stores(
  { mess: "message_id,group_id,created_at" }
)

db.version(1).stores(
  { users: "uid,full_name,phone,name_contact,name_display"}
)

db.version(1).stores(
  { contacts: "phone,name"}
)

db.version(2).stores(
  { noti: "group_id"}
)

db.version(3).stores(
  { polls: "group_id"}
)

db.users.each((user, cursor) => {
  if (user) {
    globalUser.addUser(user.id, user)  
  }
})

export default db


// import { users, addUser } from './globalUser';

// const {rxChangeSlugSearch, rxChangeSlug } = global.rootRequire('classes/ulti')
// const { rxgetLocal } = global.rootRequire('classes/request')

// class ClassIndexedDB {
//   constructor(_dbName) {
//     this.dbName = _dbName
//     this.dbVersionNumber = 1
//   }

//   setDBVersionNumber(_dbVersionNumber) {
//     this.dbVersionNumber = _dbVersionNumber
//   }

//   open() {
//     let indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;
//     this.request = indexedDB.open(this.dbName, this.dbVersionNumber)

//     this.request.onerror = event => console.log('open db error')
//     this.request.onsuccess = event => {
//       try {
//         this.db = this.request.result
//         console.log('open db success');
//         IndexedDB.readAllUsers()
//       } catch(e) {}
//     }

//     this.request.onupgradeneeded = event => {
//       let db = event.target.result

//       let arrCollections = [
//         {name: 'netaGroups', arrIndex: ['group_id', 'timestamp', 'group_fullname']},
//         {name: 'rxusers', arrIndex: ['id', 'full_name', 'phone', 'name_contact', 'name_display']},
//         {name: 'netaMess', arrIndex: ['group_id', 'created_at', 'message_id']}
//       ]

//       for (let coll of arrCollections) {
//         let objectStore = db.createObjectStore(coll.name, { autoIncrement: false  })
//         for (let indexName of coll.arrIndex) {
//           objectStore.createIndex('by_'+indexName, indexName)
//         }       
//       }

//       console.log('open db upgradedneeded');
//     }
//   }
//   readByName(objName, value,limit , callback) {
//     let i = 0
//     let groups = []
//     let objectStore 
//     switch(objName) {
//       case 'netaGroups':
//         objectStore = this.db.transaction(objName).objectStore(objName).index('by_group_fullname')
//         break;
//       case 'rxusers':
//         objectStore = this.db.transaction(objName).objectStore(objName).index('by_name_display')
//         break;
//       default:
//         // code block
//     }

//     objectStore.openCursor().onsuccess = function (event) {
//       let cursor = event.target.result
//       if (cursor) {
//         if(i < limit ){
//           if (cursor.value.type !== 3 && rxChangeSlugSearch(cursor.key).indexOf(value) !== -1) {     
//             groups.push(cursor.value) 
//             i++          
//           } 
//         }else if (i === limit){
//             callback(groups)
//             i++
//         }
//         cursor.continue()
//       }
//       else {
//         if( i < limit){
//           callback(groups)
//         }
//         console.log("No more entries!")
//       }
//     }

//   }

//   readAllLimit(objName,limit ,callback) {
//     let i = 0
//     let groups = []
//     let objectStore = this.db.transaction(objName).objectStore(objName)
//     console.log(objectStore)
//     objectStore.openCursor().onsuccess = function (event) {

//       let cursor = event.target.result
//       if (cursor) {
//         console.log(cursor.value)
//         if(i < limit ){ 
//             groups.push(cursor.value) 
//             i++       
//         }else if (i === limit){
//             callback(groups)
//             i++
//         }
//         cursor.continue()
//       }
//       else {
//         callback(groups)
//         console.log("No more entries!")
//       }
//     }
//   }

//   searchAllLimit(objName,value,limit,callback) {
//     let i = 0
//     let groups = []
//     let objectStore = this.db.transaction(objName).objectStore(objName)
//     objectStore.openCursor().onsuccess = function (event) {
//       let cursor = event.target.result
//       if (cursor) {
//         if (rxChangeSlug(cursor.value.name_display).indexOf(rxChangeSlug(value)) !== -1 || rxChangeSlug(cursor.value.phone).indexOf(rxChangeSlug(value)) !== -1) {
//           if(i < limit ){ 
//               groups.push(cursor.value) 
//               i++       
//           }else if (i === limit){
//               callback(groups)
//               i++
//           }
//         }
//         cursor.continue()
//       }
//       else {
//         callback(groups)
//         console.log("No more entries!")
//       }
//     }
//   }

//   readAll(objName, callback) {
//     let objectStore = this.db.transaction(objName).objectStore(objName)
//     objectStore.openCursor().onsuccess = function (event) {
//       let cursor = event.target.result
//       if (cursor) {
//         callback(cursor)
//         cursor.continue()
//       }
//       else {
//         console.log("No more entries!")
//       }
//     }
//   }

//   read(objName, id) {
//     try {
//       let transaction = this.db.transaction([objName])
//       let objectStore = transaction.objectStore(objName)
//       let keySearch = '' + id

//       return new Promise((resolve, reject) => {
//         let request = objectStore.get(id)
//         request.onerror = event => console.log(event)
//         request.onsuccess = event => console.log(request.result)
//       })
//     } catch(e) {}
//   }

//   add(objName, objData) {
//     console.log(this.db)
//     let transaction = this.db.transaction([objName], 'readwrite')
//     let objectStore = transaction.objectStore(objName)

//     return new Promise((resolve, reject) => {
//       let request = objectStore.add(objData)
//       // request.onsuccess = event => console.log(event)
//       // request.onerror = event => console.log(event)
//     })
//   }

//   put(objName, objData, key) {
//     if (this.db) {
//       try {
//         let transaction = this.db.transaction([objName], 'readwrite')
//         let objectStore = transaction.objectStore(objName)

//         return new Promise((resolve, reject) => {
//           let request = objectStore.put(objData, key)
//           // request.onsuccess = event => console.log(event)
//           // request.onerror = (event) => console.log(event)
//         })
//       } catch(e) {
//         console.log(e)
//       }  
//     }
    
//   }

//   get(objName, id, callback) {
//     if (this.db) {
//       try {
//         let transaction = this.db.transaction([objName])
//         let objectStore = transaction.objectStore(objName)
//         let keySearch = '' + id

//         return new Promise((resolve, reject) => {
//           let request = objectStore.get(id)
//           request.onerror = event => resolve(callback(null))
//           request.onsuccess = event => resolve(callback(request.result))
//         })
//       } catch(e) {
//         console.log(e)
//       }  
//     }
//   }

//   getLayoutData(objName, id) {
//     // try {
//     //   return new Promise ((resolve) => {
//     //     if (this.db) {
//     //       let transaction = this.db.transaction([objName])
//     //       let objectStore = transaction.objectStore(objName)
//     //       try {
//     //         let request = objectStore.get(id)
//     //         request.onerror = event => {
//     //           return resolve(null)
//     //         }
//     //         request.onsuccess = event => {
//     //           return resolve(event.target.result)
//     //         }
//     //       } catch(e) {
//     //         console.log(e)
//     //         resolve(null)
//     //       }  
//     //     } else {
//     //       resolve(null)
//     //     }
//     //   })
//     // } catch(e) {}
//   }

//   getArr(objName, filter, indexName, callback) {
//     if (this.db) {
//       try {
//         let i = 0
//         let trans = this.db.transaction([objName], 'readonly')
//         let store = trans.objectStore(objName)
//         let index = store.index('by_'+indexName)

//         let cursorRequest = index.openCursor()
        
//         let selected = []

//         cursorRequest.onsuccess = function(e) {
//           let cursor = e.target.result
//           if (!cursor) {
//             callback(selected)
//             return
//           } 
//           try {
//             var key = cursor.key
//             if (key > filter[i]) {
//               ++i
//               if (i >= filter.length) {
//                 callback(selected)
//                 return
//               }
//             }
//             if (key === filter[i]) {
//               selected.push(cursor.value)
//               cursor.continue()
//             } else {
//               console.log(filter[i])
//               cursor.continue(filter[i])
//             }

            

//           } catch(e) {
//             console.log(selected)
//             console.log(e)
//             // callback(selected)
//           }
//         }
//       } catch(e) {
//         console.log(e.message)
//       }  
//     }
//   }

//   remove(objName, id) {
//     let transaction = this.db.transaction([objName], 'readwrite')
//     let objectStore = transaction.objectStore(objName)
//     let keySearch = '' + id

//     return new Promise((resolve, reject) => {
//       let request = objectStore.delete(id)
//       // request.onerror = event => console.log(event)
//       // request.onsuccess = event => console.log(event)
//     })
//   }

//   deleteDatabase() {
//     if (this.db) {
//       this.db.close()
//       var req = window.indexedDB.deleteDatabase(this.dbName)
//       req.onsuccess = () => { console.log("Deleted database successfully") }
//       req.onerror = () => { console.log("Couldn't delete database") }
//       req.onblocked = () => { console.log("Couldn't delete database due to the operation being blocked") }  
//     }
//   }

//   readAllUsers() {
//     if (this.db) {
//       try {
//         let objectStore = this.db.transaction('rxusers').objectStore('rxusers')
//         objectStore.openCursor().onsuccess = function (event) {
//           let cursor = event.target.result
//           if (cursor) {
//             let user = cursor.value
//             if (user && user.id) {
//               let userNew = {
//                 id: user.id,
//                 name_display: user.name_display || '',
//                 profile_url: user.profile_url || '',
//                 full_name: user.name_display || '',
//                 phone: user.phone || ''
//               }

//               addUser(user.id, userNew)   
//             }
//             cursor.continue()
//           }else {
//             console.log("No more entries!")
//           }
//         } 
//       } catch(e) {}
//     }
//   }
// }

// let IndexedDB = new ClassIndexedDB("chatstore")

// if (!IndexedDB.db) {
//   IndexedDB.open()
// }

// export default IndexedDB



// getUserName(occupants_uins, ogroup) {
//     if (occupants_uins && occupants_uins.constructor === Array && occupants_uins.length > 0) {
//       let occupantsUins = occupants_uins.map(o => Number(o)).sort()
//       IndexedDB.getArr('rxusers', occupantsUins, "id", (data)=>{
//         let memberName = {}
//         for (let u of data) {
//           if (!memberName[u.id]) {
//             memberName[u.id] = {
//               profile_url: u.profile_url,
//               name_display: u.name_display
//             } 
//           }
//         }
//         ogroup.members = memberName
//         this.props.chooseGroupAction(ogroup)
//       })
//     } else {
//       this.props.chooseGroupAction(ogroup)
//     } 
//   }